import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalCarWashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_car_wash"}/>
}
